export default __webpack_public_path__ + "static/media/ic_people.f9f7a747.svg";